const REPORTING_LOCALES = new Set(['tr', 'en']);

const REPORTING_CULTURES = {
    tr: 'tr-TR',
    en: 'en-US',
};

const DEFAULT_MESSAGES = {
    tr: {
        loadingReport: 'Rapor yükleniyor…',
        exitDesigner: 'Tasarımcıdan çık',
        viewerServerError: 'Rapor yüklenirken sunucu hatası oluştu.',
        designerServerError: 'Rapor tasarımcısında sunucu hatası oluştu.',
        'office.defaultSheetName': 'Sayfa1',
        'office.errors.compare': 'Doküman karşılaştırılamadı.',
        'office.errors.trackChanges': 'Değişiklikleri izleme ayarı güncellenemedi.',
        'office.errors.mailMerge': 'Word birleştirme işlemi tamamlanamadı.',
        'office.errors.excel': 'Excel dosyası oluşturulamadı.',
        'office.errors.watermark': 'Filigran eklenemedi.',
        'office.errors.protection': 'Doküman koruması uygulanamadı.',
        'office.errors.pdf': 'PDF dönüştürme işlemi tamamlanamadı.',
        'office.errors.comment': 'Yorum eklenemedi.',
        'office.errors.pdfArchival': 'PDF/A dönüştürme işlemi tamamlanamadı.',
        'office.errors.qr': 'QR kod eklenemedi.',
        'office.errors.metadata': 'Doküman üst verisi güncellenemedi.',
        'office.errors.validation': 'Doküman doğrulanamadı.',
    },
    en: {
        loadingReport: 'Loading report…',
        exitDesigner: 'Exit designer',
        viewerServerError: 'A server error occurred while loading the report.',
        designerServerError: 'A server error occurred in the report designer.',
        'office.defaultSheetName': 'Sheet1',
        'office.errors.compare': 'The documents could not be compared.',
        'office.errors.trackChanges': 'The Track Changes setting could not be updated.',
        'office.errors.mailMerge': 'The Word mail merge could not be completed.',
        'office.errors.excel': 'The Excel file could not be generated.',
        'office.errors.watermark': 'The watermark could not be added.',
        'office.errors.protection': 'Document protection could not be applied.',
        'office.errors.pdf': 'The PDF conversion could not be completed.',
        'office.errors.comment': 'The comment could not be added.',
        'office.errors.pdfArchival': 'The PDF/A conversion could not be completed.',
        'office.errors.qr': 'The QR code could not be added.',
        'office.errors.metadata': 'The document metadata could not be updated.',
        'office.errors.validation': 'The document could not be validated.',
    },
};

export function normalizeReportingLocale(locale, fallback = 'tr') {
    const normalized = String(locale || '').trim().toLowerCase().split(/[-_]/)[0];
    if (REPORTING_LOCALES.has(normalized)) return normalized;
    return REPORTING_LOCALES.has(fallback) ? fallback : 'tr';
}

export function reportingCulture(locale) {
    if (!locale) return undefined;
    return REPORTING_CULTURES[normalizeReportingLocale(locale)];
}

export function reportingMessages(locale, overrides = {}) {
    const normalized = normalizeReportingLocale(locale);
    return {
        ...DEFAULT_MESSAGES[normalized],
        ...(overrides?.[normalized] || overrides || {}),
    };
}
